/**
 * Content hierarchy for navigation
 * Defines the structure and labels for the navigation menu
 *
 * @file Navigation structure definitions
 */

/**
 * Content hierarchy for navigation
 * Note: Individual indicator navigation titles are now in indicatorsContent
 * @type {Array<Object>}
 */
const contentHierarchy = [
  {
    navTitle: 'Caractéristiques de {{the_entity}}',
    contentTitle: 'Caractéristiques de {{the_entity}}',
    key: 'caracteristiques',
    iconKey: null,
    items: []
  },
  {
    navTitle: 'Climat',
    contentTitle: 'Indicateurs \'Climat\'',
    key: 'general',
    iconKey: null,
    items: [
      {
        key: 'G1',
        isIndicator: true
      },
      {
        key: 'G2',
        isIndicator: true
      },
      {
        key: 'G3',
        isIndicator: true
      },
      {
        key: 'G4',
        isIndicator: true
      },
      {
        key: 'G5',
        isIndicator: true
      }
    ]
  },
  {
    navTitle: 'Risques naturels',
    contentTitle: 'Indicateurs \'Risques naturels\'',
    key: 'risques',
    iconKey: null,
    items: [
      {
        key: 'R1',
        isIndicator: true
      },
      {
        key: 'R2',
        isIndicator: true
      },
      {
        key: 'R3',
        isIndicator: true
      },
      {
        key: 'R4',
        isIndicator: true
      },
      {
        key: 'R5',
        isIndicator: true
      },
      {
        key: 'R6',
        isIndicator: true
      },
      {
        key: 'R7',
        isIndicator: true
      },
      {
        key: 'R9',
        isIndicator: true
      },
      {
        key: 'R8',
        isIndicator: true
      }
    ]
  },
  {
    navTitle: 'Santé',
    contentTitle: 'Indicateurs \'Santé\'',
    key: 'sante',
    iconKey: null,
    items: [
      {
        key: 'S1',
        isIndicator: true
      },
      {
        key: 'S2',
        isIndicator: true
      },
      {
        key: 'S3',
        isIndicator: true
      },
      {
        key: 'S4',
        isIndicator: true
      },
      {
        key: 'S5',
        isIndicator: true
      },
      {
        key: 'S6',
        isIndicator: true
      },
      {
        key: 'S7',
        isIndicator: true
      },
      {
        key: 'S8',
        isIndicator: true
      },
      {
        key: 'S9',
        isIndicator: true
      },
      {
        key: 'S10',
        isIndicator: true
      },
      {
        key: 'S11',
        isIndicator: true
      }
    ]
  },
  {
    navTitle: 'Agriculture',
    contentTitle: 'Indicateurs \'Agriculture\'',
    key: 'agri',
    iconKey: null,
    items: [
      {
        key: 'AG1',
        isIndicator: true
      },
      {
        key: 'AG2',
        isIndicator: true
      },
      {
        key: 'AG3',
        isIndicator: true
      },
      {
        key: 'AG4',
        isIndicator: true
      },
      {
        key: 'AG5',
        isIndicator: true
      },
      {
        key: 'AG6',
        isIndicator: true
      },
      {
        key: 'AG7',
        isIndicator: true
      },
      {
        key: 'AG8',
        isIndicator: true
      },
      {
        key: 'AG9',
        isIndicator: true
      },
      {
        key: 'AG10',
        isIndicator: true
      },
      {
        key: 'AG11',
        isIndicator: true
      },
      {
        key: 'AG12',
        isIndicator: true
      },
      {
        key: 'AG13',
        isIndicator: true
      }
    ]
  },
  {
    navTitle: 'Tourisme',
    contentTitle: 'Indicateurs \'Tourisme\'',
    key: 'tourisme',
    iconKey: null,
    items: [
      {
        key: 'T1',
        isIndicator: true
      },
      {
        key: 'T2',
        isIndicator: true
      },
      {
        key: 'T3',
        isIndicator: true
      },
      {
        key: 'T4',
        isIndicator: true
      },
      {
        key: 'T5',
        isIndicator: true
      },
      {
        key: 'T6',
        isIndicator: true
      },
      {
        key: 'T7',
        isIndicator: true
      }
    ]
  },
  {
    navTitle: 'Comprendre',
    contentTitle: 'Comprendre',
    key: 'comprendre',
    iconKey: null,
    items: [
      {
        navTitle: 'Pourquoi Climadiag commune ?',
        contentTitle: 'Pourquoi Climadiag commune ?',
        key: 'pourquoi',
        isIndicator: false
      },
      {
        navTitle: 'Comprendre les infographies',
        contentTitle: 'Comprendre les infographies',
        key: 'figures',
        isIndicator: false
      }
    ]
  },
];

export default contentHierarchy;
